var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-content", attrs: { id: "patrol-form" } },
    [
      _c(
        "Titlebar",
        {
          attrs: {
            incrustation: "fa-history",
            backPath: _vm.$route.query.patrolid,
          },
        },
        [_c("h1", [_vm._v(_vm._s(_vm.$t("patrol.titles.compare")))])]
      ),
      _vm._v(" "),
      _vm.timelineError
        ? _c("div", {
            staticClass: "patrol-error mb-4",
            domProps: { innerHTML: _vm._s(_vm.timelineErrorMessage) },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "UiCard",
        [
          _c("div", { staticClass: "row selection-header" }, [
            _c("div", { staticClass: "col-6" }, [
              _c("div", { staticClass: "selection-block show w-25" }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "selection-block w-25",
                  class: { show: _vm.canTheoricStart },
                },
                [
                  _c("label", [
                    _vm._v(_vm._s(_vm.$t("patrol.compare.form.theoricStart"))),
                  ]),
                  _vm._v(" "),
                  _c("ClockPicker", {
                    attrs: { nullable: true, inputclass: "form-input" },
                    model: {
                      value: _vm.theoricStart,
                      callback: function ($$v) {
                        _vm.theoricStart = $$v
                      },
                      expression: "theoricStart",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "selection-block show w-50" }, [
                _c("label", [
                  _vm._v(_vm._s(_vm.$t("patrol.compare.form.patrol"))),
                ]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.selectedPatrolId,
                        expression: "selectedPatrolId",
                      },
                      {
                        name: "can",
                        rawName: "v-can",
                        value: "beepiz-select-patrols",
                        expression: "'beepiz-select-patrols'",
                      },
                    ],
                    staticClass: "form-input",
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.selectedPatrolId = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                    },
                  },
                  _vm._l(_vm.filteredPatrols, function (patrol) {
                    return _c(
                      "option",
                      { key: patrol.id, domProps: { value: patrol.id } },
                      [
                        _vm._v(
                          _vm._s(patrol.name) + "\n                        "
                        ),
                      ]
                    )
                  }),
                  0
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-6" }, [
              _c("div", { staticClass: "selection-block show w-50" }, [
                _c("label", [
                  _vm._v(_vm._s(_vm.$t("patrol.compare.form.resource"))),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "on-clickaway",
                        rawName: "v-on-clickaway",
                        value: _vm.closeResourceSelector,
                        expression: "closeResourceSelector",
                      },
                    ],
                    staticClass: "resource-selector-container",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "form-input resource-selector-selection",
                        class: _vm.showResourceSelector && "focus",
                        on: { click: _vm.toggleResourceSelector },
                      },
                      [
                        _c("i", { staticClass: "fa fa-caret-down" }),
                        _vm._v(
                          _vm._s(_vm.selectedResourceLabel) +
                            "\n                        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "resource-selector-wrapper",
                        class: { show: _vm.showResourceSelector },
                      },
                      [
                        _c("ResourceSelector", {
                          attrs: {
                            preselected: _vm.resourcePreselected,
                            config: _vm.resourceSelectorConfig,
                          },
                          on: { change: _vm.handleChangeResourcesSelection },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "selection-block show w-25" },
                [
                  _c("label", [
                    _vm._v(_vm._s(_vm.$t("patrol.compare.form.date"))),
                  ]),
                  _vm._v(" "),
                  _c("DatePicker", {
                    attrs: { inputclass: "form-input", max: _vm.getNow },
                    model: {
                      value: _vm.selectedDate,
                      callback: function ($$v) {
                        _vm.selectedDate = $$v
                      },
                      expression: "selectedDate",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "selection-block w-25",
                  class: { show: _vm.starts.length > 0 },
                },
                [
                  _c("label", [
                    _vm._v(_vm._s(_vm.$t("patrol.compare.form.startedAt"))),
                  ]),
                  _vm._v(" "),
                  _vm.starts.length <= 6
                    ? _c("div", { staticClass: "patrol-selector" }, [
                        _c(
                          "ul",
                          _vm._l(_vm.starts, function (start) {
                            return _c(
                              "li",
                              {
                                class: {
                                  active:
                                    _vm.convertToTime(start) == _vm.startedAt,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.setStartedAt(start)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.convertToTime(start)) +
                                    "\n                            "
                                ),
                              ]
                            )
                          }),
                          0
                        ),
                      ])
                    : _c(
                        "select",
                        {
                          staticClass: "form-input",
                          on: { change: _vm.handleStartChange },
                        },
                        [
                          _c("option", [_vm._v("Choisir")]),
                          _vm._v(" "),
                          _vm._l(_vm.startDays, function (day) {
                            return _c(
                              "optgroup",
                              { attrs: { label: day } },
                              _vm._l(_vm.startsForDay(day), function (start) {
                                return _c(
                                  "option",
                                  { domProps: { value: start } },
                                  [_vm._v(_vm._s(_vm.convertToTime(start)))]
                                )
                              }),
                              0
                            )
                          }),
                        ],
                        2
                      ),
                ]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("Timeline", {
            class: { "timeline-blur": _vm.timelineError },
            attrs: {
              theoric: _vm.getTheoricCheckpoints,
              real: _vm.realPatrol,
              theoricStart: _vm.getTheoricStart,
              realStart: _vm.getRealStart,
              manageTime: _vm.getManageTime,
              apDefs: _vm.apDefs,
              zoom: _vm.zoom,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("Toolbar", [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col" },
            [
              _c(
                "Btn",
                {
                  directives: [
                    {
                      name: "can",
                      rawName: "v-can",
                      value: "beepiz-download-common",
                      expression: "'beepiz-download-common'",
                    },
                  ],
                  class: ["default pull-left", { disabled: !_vm.canConsult }],
                  nativeOn: {
                    click: function ($event) {
                      return _vm.dlReport($event)
                    },
                  },
                },
                [
                  _c("i", { staticClass: "fa fa-file-pdf-o" }),
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("patrol.btns.print")) +
                      "\n                "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col center" },
            [
              _c("Zoom", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isZoomable,
                    expression: "isZoomable",
                  },
                ],
                attrs: { min: 10, max: 30, step: 5, label: "Echelle" },
                model: {
                  value: _vm.zoom,
                  callback: function ($$v) {
                    _vm.zoom = $$v
                  },
                  expression: "zoom",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col" }),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }